import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

const fetchCoursesEffort = async (courseIds) => {
  const url = `${getConfig().LMS_BASE_URL}/blendxapi/discovery/courses/effort/`;
  const { data } = await getAuthenticatedHttpClient().post(url, {
    course_ids: courseIds,
  });
  return data;
};

export const useCoursesEffort = (courseIds) => {
  const uniqueIds = useMemo(
    () => Array.from(new Set((courseIds || []).filter(Boolean))).sort(),
    [courseIds],
  );

  const { data } = useQuery({
    queryKey: ['coursesEffort', uniqueIds],
    queryFn: () => fetchCoursesEffort(uniqueIds),
    enabled: uniqueIds.length > 0,
    staleTime: 60 * 60 * 1000,
  });

  return {
    effortByCourseId: data || {},
  };
};
